import { useCallback, useEffect, useState } from "react";
import { api, lerToken, limparToken, type Ator } from "./api.js";
import { Casca, useRota } from "./Casca.js";
import { iniciarTema } from "./tema.js";
import { Entrar } from "./telas/Entrar.js";
import { Painel } from "./telas/Painel.js";
import { Numeros } from "./telas/Numeros.js";
import { Planos } from "./telas/Planos.js";
import { Fila } from "./telas/Fila.js";
import { Campanhas } from "./telas/Campanhas.js";
import { Produtos } from "./telas/Produtos.js";
import { Kits } from "./telas/Kits.js";
import { Repertorio } from "./telas/Repertorio.js";
import { Conversas } from "./telas/Conversas.js";
import { Crm } from "./telas/Crm.js";
import { Leads } from "./telas/Leads.js";
import { Historico } from "./telas/Historico.js";
import { Usuarios } from "./telas/Usuarios.js";
import { Config } from "./telas/Config.js";

type Estado =
  | { fase: "verificando" }
  | { fase: "fora" }
  | { fase: "dentro"; ator: Ator };

/** Cada seção da casca tem exatamente um componente. */
const TELAS: Record<string, () => JSX.Element> = {
  painel: Painel,
  numeros: Numeros,
  planos: Planos,
  fila: Fila,
  campanhas: Campanhas,
  "campanhas/produtos": Produtos,
  "campanhas/kits": Kits,
  "planos/mensagens": Repertorio,
  "leads/conversas": Conversas,
  leads: Leads,
  crm: Crm,
  historico: Historico,
  usuarios: Usuarios,
  config: Config,
};

export function App(): JSX.Element {
  const [estado, setEstado] = useState<Estado>({ fase: "verificando" });
  const rota = useRota();

  useEffect(iniciarTema, []);

  const reidratar = useCallback(() => {
    if (!lerToken()) {
      setEstado({ fase: "fora" });
      return;
    }
    api
      .quemSou()
      .then((r) => setEstado({ fase: "dentro", ator: r.usuario }))
      .catch(() => {
        limparToken();
        setEstado({ fase: "fora" });
      });
  }, []);

  useEffect(reidratar, [reidratar]);

  const sair = useCallback(() => {
    limparToken();
    setEstado({ fase: "fora" });
  }, []);

  if (estado.fase === "verificando") {
    return (
      <div className="min-h-full grid place-items-center text-tinta-3 text-sm">
        …
      </div>
    );
  }

  if (estado.fase === "fora") return <Entrar aoEntrar={reidratar} />;

  const Tela = TELAS[rota] ?? Painel;

  return (
    <Casca ator={estado.ator} aoSair={sair}>
      <Tela />
    </Casca>
  );
}
